<template>
  <div class="row spinner-parent">
    <div class="col-12">
      <div class="card">
        <div class="card-header">
          <h1>Create Image</h1>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Title *</label>
                  <div class="col-md-10">
                    <input
                      id="title"
                      v-model="entity.title"
                      type="text"
                      placeholder="Enter title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Date</label>
                  <div class="col-md-10">
                    <datepicker
                      v-model="entity.date"
                      format="yyyy-MM-dd"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="summary" class="col-md-2">Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="summary" v-model="entity.summary" />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Media *</label>
                  <div class="col-md-10">
                    <!-- <image-uploader
                      @changeFile="changeMedia"
                    /> -->
                    <FileUploader
                      v-model="imageFile"
                      check-type="media_image"
                      path-prefix="img"
                      :dropzone-options="dropzoneOptions"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Galleries</label>
                  <div class="col-md-10">
                    <multiselect-remote
                      v-model="entity.galleries"
                      :default-options="defaultOptions.galleries"
                      :search-function="galleriesSearch"
                      label="title"
                    />
                  </div>
                </div>

                <div class="form-group row">
                  <label for="published" class="col-md-2">Published</label>
                  <div class="col-md-10">
                    <input id="published" v-model="entity.published" type="checkbox">
                  </div>
                </div>

                <div class="form-group row">
                  <label for="featured" class="col-md-2">Featured Content</label>
                  <div class="col-md-10">
                    <select id="featured" v-model="entity.featured" class="form-control" name="featured">
                      <option v-for="(item, key) in $_featuredBlocksList" :key="item" :value="key">{{ item }}</option>
                    </select>
                  </div>
                </div>

                <div v-if="entity.featured" class="form-group row">
                  <label for="bio" class="col-md-2">Featured Summary</label>
                  <div class="col-md-10">
                    <ckeditor id="featured_body" v-model="entity.featuredBody" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <strong>SEO</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="seo_title" class="col-md-2">Title</label>
                  <div class="col-md-10">
                    <input
                      id="seo_title"
                      v-model="entity.seo_title"
                      type="text"
                      placeholder="Enter SEO title"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label class="col-md-2">Description</label>
                  <div class="col-md-10">
                    <textarea id="seo_desc" v-model="entity.seo_description" class="form-control" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <referencer
        @changeRefs="$_changeRefs"
      />

      <terms
        @changeTerms="$_changeTerms"
      />

      <div class="card">
        <div class="card-header">
          <strong>Path Alias</strong>
        </div>
        <div class="card-body form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="path_alias" class="col-md-2">{{ $config.app_api.host }}</label>
                  <div class="col-md-10">
                    <input
                      id="path_alias"
                      v-model="entity.path_alias"
                      type="text"
                      placeholder="Enter path alias"
                      class="form-control"
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Image has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import MultiselectRemote from '@/global/components/MultiselectRemote';
import Datepicker from '@/global/components/Datepicker';
import Referencer from '@/global/components/Referencer';
import Terms from '@/global/components/TermsEditor';
import FileUploader from '@/global/components/FileUploader/Index';
import config from '../../../config';
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';
import DefaultOptionsRequests from '@/mixins/DefaultOptionsRequests';

export default {
  name: 'ImageNew',

  components: {
    'multiselect-remote': MultiselectRemote,
    datepicker: Datepicker,
    referencer: Referencer,
    terms: Terms,
    FileUploader,
  },

  mixins: [CreatePageMixin, DefaultOptionsRequests],

  data() {
    return {
      entity: {
        title: null,
        date: null,
        body: null,
        summary: null,
        media: null,
        galleries: [],
        seo_title: '',
        seo_description: '',
        path_alias: '',
        published: true,
        featured: false,
        featuredBody: '',
      },
      imageFile: null,
      dropzoneOptions: {
        url: '/', // There are no link because we dont need to upload files immediately
        maxFiles: 1,
        maxFilesize: 2048,
        addRemoveLinks: true,
        acceptedFiles: 'image/*',
        autoProcessQueue: false,
        accept() {},
      },
    };
  },

  mounted() {
    this.$_getDefaultGalleries();
  },

  methods: {
    galleriesSearch: _.debounce((loading, search, vm, searchRequestId) => {
      const context = vm;
      vm.$apiHttp.get(`${vm.$config.app_api.prefix}media/image-galleries?search_string=${escape(search)}`)
        .then((response) => {
          if (!vm.searchQuery || vm.searchRequestId !== searchRequestId) return;
          const newDataArr = _.cloneDeep(response.data);
          delete newDataArr.meta;
          context.options = Object.keys(newDataArr).map(e => newDataArr[e]);
          loading(false);
        })
        .catch((error) => {
          loading(false);
          console.error(error);
        });
    }, 350),
    isEntityValid() {
      return this.$_validate([
        { name: 'Title', value: this.entity.title, type: 'required' },
        { name: 'Title', value: this.entity.title, type: 'maxLength', maxLength: 255 },
        { name: 'Path Alias', value: this.entity.path_alias, type: 'path' },
      ]);
    },
    saveRequest() {
      const postFormData = this.$_addDefaultFormData();
      postFormData.append('title', this.entity.title);
      postFormData.append('body', this.entity.body ? this.entity.body : '');
      if (this.imageFile.uploadType === 'file') {
        // postFormData.append('media', this.imageFile.file);
        postFormData.append('chunkedFile', true);
      } else {
        postFormData.append('selectel_file_url', this.imageFile.fileLink);
      }
      for (let i = 0; i < this.entity.galleries.length; i += 1) {
        postFormData.append('gallery_ids[]', this.entity.galleries[i].id);
      }
      if (this.entity.date) postFormData.append('date', this.entity.date);
      if (this.entity.featured) postFormData.append('featured', _.toNumber(this.entity.featured));
      if (this.entity.featuredBody) postFormData.append('featured_body', this.entity.featuredBody);
      return this.$apiHttp.post(`${this.$config.app_api.prefix}media/images`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      const { file, uploadType } = this.imageFile;
      const { prefix, host } = this.$config.app_api;
      const token = JSON.parse(localStorage.getItem(config.tokenStorage.name));
      const { acceptedFiles } = this.dropzoneOptions;
      this.saveRequest().then((response) => {
        this.$_successSave();
        if (file && uploadType === 'file') {
          this.$store.dispatch('uploadManager/startUpload', {
            apiHost: host,
            apiPrefix: prefix,
            entityId: response.data.id,
            files: [file],
            token,
            acceptedFiles,
            contentType: response.data.content_type,
          });
        }
        this.$parent.getSource();
        window.location.hash = `#/admin/content/media_image/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create image query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?3ef499c9